import styles from './MessagesList.module.css';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const MessagesList = ({
  messages,
  phoneNumberFontSize,
  authorFontSize,
  msgFontSize,
  currentState,
  winId,
  speed,
  winIds,
  msgDataField,
}) => {
  return (
    <div className={styles['wrapper']}>
      {currentState && currentState !== 'S1' && messages.length > 3 && (
        <div className={styles['messagesWrapper']}>
          <TransitionGroup className={styles['messages']} appear={true}>
            {messages.length > 0 &&
              messages.map((item, i) => (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position">
                  <Message
                    winId={winId}
                    key={item.id}
                    message={item.message}
                    titrTag={item.titrTag}
                    authorFontSize={authorFontSize}
                    msgFontSize={msgFontSize}
                    phoneNumberFontSize={phoneNumberFontSize}
                    currentState={currentState}
                    winIds={winIds}
                    msgDataField={msgDataField}
                  />
                </CSSTransition>
              ))}
          </TransitionGroup>
        </div>
      )}
    </div>
  );
};

export default MessagesList;
